// extracted by mini-css-extract-plugin
export default {"section":"section_section__LlwQ6","title":"section_title__IGvDk","content":"section_content__9DIs2"};